<template>
  <div class="page">
    <div class="page__bd">
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__bd form-detail-preview">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">需求日期</label>
            <span class="weui-form-preview__value" v-format="'yyyy-MM-dd'">{{item.dt_delivery}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">追踪日期</label>
            <span class="weui-form-preview__value" v-format="'yyyy-MM-dd'">{{item.createTime}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">采购单号</label>
            <span class="weui-form-preview__value">{{item.dt_code}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">供应商</label>
            <span class="weui-form-preview__value">{{item.main_vendname}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">采购序号</label>
            <span class="weui-form-preview__value">{{item.detail_detno}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">物料编号</label>
            <span class="weui-form-preview__value">{{item.pr_code}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">物料名称</label>
            <span class="weui-form-preview__value">{{item.pr_detail}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">型号</label>
            <span class="weui-form-preview__value">{{item.pr_orispeccode}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">品牌</label>
            <span class="weui-form-preview__value">{{item.pr_brand}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">数量</label>
            <span class="weui-form-preview__value">{{item.dt_qty}}{{item.pr_unit}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">未交数量</label>
            <span class="weui-form-preview__value">{{item.dt_nqty}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    var item = this.$route.params.item
    return {
      item,
    }
  }
}
</script>